import React from 'react';
import { SVGAttributes } from 'react';

export const BulkManagementIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8333 16.6673H4.16667C2.83333 16.6673 2.5 15.5565 2.5 15.0007V5.00065C2.5 4.55862 2.67559 4.1347 2.98816 3.82214C3.30072 3.50958 3.72464 3.33398 4.16667 3.33398H12.5C12.942 3.33398 13.366 3.50958 13.6785 3.82214C13.9911 4.1347 14.1667 4.55862 14.1667 5.00065V10.0007M15.8333 16.6673C15.2775 16.6673 14.1667 16.334 14.1667 15.0007V10.0007M15.8333 16.6673C17.1667 16.6673 17.5 15.5565 17.5 15.0007V10.0007H14.1667"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 13H11.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.5 9.5H11.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BulkManagementIcon;
